export default "__VITE_ASSET__DzFzq1Mi__"